/*
  Product recommendations — sections/product-recommendations.liquid
  -----------------------------------------------------------------
  The API sources render a skeleton row on the page and publish the Section Rendering
  URL that returns this same section with `recommendations` resolved. This fetches it,
  swaps only the card list in — the heading and controls stay — and then hands the
  rail to the scripts that already own cards and carousels:

    • `data-carousel` goes on the row now, not in Liquid, so assets/carousel.js could
      not have mounted on the placeholders and kept their slide list.
    • `product-grid:updated` is what assets/product-card.js listens for after any
      re-render of cards, wherever they are; the name is the grid's, the contract is not.

  A response with no cards hides the section: nothing to recommend is not an error.
*/
(function () {
  if (window.__productRecommendations) return;
  window.__productRecommendations = true;

  function load(root) {
    var url = root.getAttribute('data-recommendations-url');
    if (!url || root.__recommendationsLoaded) return;
    root.__recommendationsLoaded = true;

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Recommendations request failed: ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations-list]');
        var list = root.querySelector('[data-recommendations-list]');
        if (!fresh || !list || !fresh.children.length) {
          empty(root);
          return;
        }

        list.innerHTML = fresh.innerHTML;
        root.classList.remove('recs--loading');

        var row = root.querySelector('.splide');
        if (row) row.setAttribute('data-carousel', '');
        if (window.themeCarousel) window.themeCarousel.refresh(root);

        document.dispatchEvent(
          new CustomEvent('product-grid:updated', { detail: { root: root }, bubbles: true })
        );
      })
      .catch(function () {
        empty(root);
      });
  }

  // The skeletons go too: the section's own `:has()` gate counts them as content.
  function empty(root) {
    var list = root.querySelector('[data-recommendations-list]');
    if (list) list.innerHTML = '';
    root.classList.remove('recs--loading');
    root.classList.add('recs--empty');
  }

  /* Fetched as the rail nears the viewport, not on mount: below the fold its cards'
     images would otherwise share the connection with the gallery above them. */
  var NEAR = '600px';
  var watcher = null;

  function watch(root) {
    if (typeof IntersectionObserver === 'undefined') return load(root);
    if (!watcher) {
      watcher = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          watcher.unobserve(entries[i].target);
          load(entries[i].target);
        }
      }, { rootMargin: NEAR });
    }
    watcher.observe(root);
  }

  function loadAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-recommendations]');
    for (var i = 0; i < roots.length; i++) watch(roots[i]);
  }

  function ready() {
    loadAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  // Theme editor lifecycle: a re-rendered section is a new skeleton to fill.
  document.addEventListener('shopify:section:load', function (e) {
    loadAll(e.target);
  });
})();
